module.exports = __webpack_public_path__ + "img/02.05959535.png";